module.exports = __webpack_public_path__ + "static/media/illu2.ee621ed1.png";